import { useState, useEffect, useCallback } from 'react';

export const useDataFetching = (fetchFunction, dependencies = [], options = {}) => {
  const { initialData = null, onSuccess = null, onError = null } = options;

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await fetchFunction();
      setData(result);
      if (onSuccess) onSuccess(result);
      return result;
    } catch (err) {
      const errorMessage = err.message || 'Failed to fetch data';
      setError(errorMessage);
      if (onError) onError(err);
      console.error('Data fetching error:', err);
    } finally {
      setLoading(false);
    }
  }, [fetchFunction, onSuccess, onError]);

  useEffect(() => {
    fetchData();
  }, dependencies);

  const refetch = useCallback(() => fetchData(), [fetchData]);

  return { data, loading, error, refetch };
};

export default useDataFetching;
